import { FC, HTMLAttributes } from "react";
import styles from "./DefaultIcon.module.scss";

interface DefaultIconProps extends HTMLAttributes<HTMLImageElement> {
  src: string;
}

export const DefaultIcon: FC<DefaultIconProps> = ({
  src,
  className,
  style,
}) => {
  return (
    <img
      className={`${className && className} ${styles.icon}`}
      alt="icon"
      style={style}
      src={src}
    />
  );
};
